@if (selectedQuery()?.deployment_requirements; as req) {
  @if (req.categories?.length) {
    <div id="deployment-category">
      <hyperkit-typography variant="h5">Category</hyperkit-typography>
      <hyperkit-typography variant="body" size="md" color="secondary">
        {{ req.categories.join(', ') }}
      </hyperkit-typography>
    </div>
  }
  @if (req.searchable_data?.length) {
    <div id="searchable-data">
      <hyperkit-typography variant="h5">Searchable Data</hyperkit-typography>
      <hyperkit-typography variant="body" size="md" color="secondary">
        {{ req.searchable_data.join(', ') }}
      </hyperkit-typography>
    </div>
  }
  @if (req.deployment_steps) {
    <div id="deployment-steps">
      <hyperkit-typography variant="h5">Deployment Steps</hyperkit-typography>
      <hyperkit-markdown [md]="req.deployment_steps"></hyperkit-markdown>
    </div>
  }
}
